import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { PROGRAMS } from "@/data/content";

export default function Programs() {
  return (
    <>
      <PageHeader
        eyebrow="Youth Development Programs"
        title="More Than A Game"
        description="Nine programs built to develop youth athletes on and off the field — through education, character, and community."
        testid="programs-header"
      />
      <section className="py-14 sm:py-20 bg-[#0A0A0A]" data-testid="programs-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="programs-grid">
            {PROGRAMS.map((program, i) => {
              const Icon = program.icon;
              return (
                <Reveal key={program.name} delay={(i % 3) * 0.1}>
                  <div
                    className="group h-full bg-[#111111] border border-[#333333] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#FEE123]/50"
                    data-testid={`program-card-${i}`}
                  >
                    <div className="w-12 h-12 flex items-center justify-center bg-[#0F4D22] rounded-sm">
                      <Icon size={24} className="text-[#FEE123]" />
                    </div>
                    <h3 className="mt-5 text-xl font-bold uppercase tracking-wide text-white">{program.name}</h3>
                    <p className="mt-3 text-sm text-gray-400 leading-relaxed">{program.description}</p>
                    <div className="mt-5 h-0.5 w-8 bg-[#FEE123] transition-all duration-300 group-hover:w-full" />
                  </div>
                </Reveal>
              );
            })}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-12 bg-[#06220F] border border-[#333333] p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6" data-testid="programs-donate-cta">
              <div>
                <h3 className="font-display text-3xl uppercase text-white">These Programs Run On Your Support</h3>
                <p className="mt-2 text-sm text-gray-300">Donations fund scholarships, tutoring, mentorship, and college exposure for our athletes.</p>
              </div>
              <Link
                to="/donate"
                data-testid="programs-donate-button"
                className="shrink-0 inline-flex items-center justify-center gap-2 bg-[#FEE123] text-black text-base font-extrabold uppercase tracking-widest px-7 py-3 rounded-sm transition-transform duration-200 hover:scale-105 hover:bg-[#FFEA61]"
              >
                Donate <ArrowRight size={18} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
